import React from "react";
import { formatAagValue, handleAagTitle, trueNumberValueFromString } from "../utils/Helpers";
import { VsiSmallText, VsiMedText, VsiLgText, VsiXLText } from "../styled/App.styled";
import { useVsiAppContext } from "../stores/VsiApp";
import { withErrorBoundary } from "../boundaries/withErrorBoundary";

import { Icon } from "../styled/AtAGlance.styled";
import { Placeholder } from "reactstrap";
import GeneralErrorBoundary from "../boundaries/GeneralErrorBoundary";
import themeStyles, { vsiGreen, vsiRed } from "../utils/themeStyles";


const AagText = ({ size, children, className, color }) => {
  switch(size.toLowerCase()) {
    case "sm":
      return <VsiSmallText color={color} className={className} $textAlign={'center'}>{children}</VsiSmallText>
    case "md":
      return <VsiMedText color={color} className={className} $textAlign={'center'}>{children}</VsiMedText>
    case "lg":
      return <VsiLgText color={color} className={className} $textAlign={'center'}>{children}</VsiLgText>
    case "xl":
      return <VsiXLText color={color} className={className} $textAlign={'center'}>{children}</VsiXLText>
    default:
      return <VsiLgText color={color} className={className} $textAlign={'center'}>{children}</VsiLgText>
  }
}

const oneSizeDown = (size) => {
  switch(size.toLowerCase()) {
    case "sm":
      return "sm";
    case "md":
      return "sm";
    case "lg":
      return "md";
    case "xl":
      return "lg";
    default:
      return "sm";
  }
}

function AaGDiff({ value, diff, size }) {
  if (!diff) return null;
  let pctDiff = '0';
  if (diff !== 0) {

    const oldVal = value - diff;
    const raw = ((value - oldVal) / Math.abs(oldVal || 1));

    const pctChange = Number(raw.toFixed(2));
    pctDiff = `${parseInt(pctChange * 100)}%`;
  }
  return <AagText className={"ms-1 fw-bold"} size={oneSizeDown(size)}>{pctDiff}</AagText>;
}

function AaGIcon({ icon, diff }) {
  if (!icon) return null;
  if (diff >= 0) return <Icon style={{ color: vsiRed }} className="fa-solid fa-caret-up" />;
  else if (diff < 0) return <Icon style={{ color: vsiGreen }} className="fa-solid fa-caret-down" />;
}

function AaGTd({ icon, diff, title, field, value, size, ignoreSuffix, dollarSign, isLoading, fieldStart, type, data}) {
  const formattedTitle = handleAagTitle(title, field);
  const { theme } = useVsiAppContext();
  const titleColor = themeStyles[theme].titleTextColor;

  const trueDiff = trueNumberValueFromString(diff);
  const trueValue = trueNumberValueFromString(value);
  return (
    <div className="d-flex flex-column justify-content-center align-items-center">
      <AagText size={size} color={titleColor}>{formattedTitle}</AagText>
      {isLoading ?
        <Placeholder size={size}
                     color={"secondary"}
                     animation={"wave"}
                     tag={"span"}
                     style={{ minHeight: 20}}
                     className={"w-100 mt-1"}/>
        : (
          <AagText size={size}>
            <span className={"fw-bold"}>
               {(dollarSign && value) ? '$' : ''}
               {formatAagValue(value, field, dollarSign)}
               {!ignoreSuffix && formattedTitle.includes("%") ? "%" : ""}
            </span>
            {type === "forecast-from" && (
              <span className={"d-inline-flex align-items-end ms-2"}>
                <AaGIcon icon={icon} diff={trueDiff} />
                <AaGDiff value={trueValue} diff={trueDiff} size={size}/>
              </span>
            )}
          </AagText>
        )}
      <div className="d-flex flex-row align-items-right">
        {type === "forecast-from" ? (
              <span className={"ms-1"}>
                <AagText size={oneSizeDown(size)}>
                  {trueDiff >= 0 ? 'Up' : 'Down'} <span className={"fw-bold"} style={{ color: trueDiff >= 0 ? vsiRed : vsiGreen }}>{diff}</span> from {data[fieldStart]}
                </AagText>
              </span>
        ) : (
          <>
            <AaGIcon icon={icon} diff={trueDiff} />
            <AaGDiff value={trueValue} diff={trueDiff} size={size}/>
          </>
        )}
        {type === "forecast-at" ? (
              <span className={"ms-1"}>
                <AagText size={oneSizeDown(size)} className={"fst-italic"}>
                  current {data[fieldStart]}
                </AagText>
              </span>
        ) : null}
      </div>
    </div>
  );
}

function AtAGlance({ config, data, size="sm", orient = "horizontal", className, isLoading }) {
  const { isTabletScreen } = useVsiAppContext();
  const trueConfig = !isTabletScreen ? [...config] : [...config].splice(0, 4);
  return (
      <div className={`w-100 h-100 my-2 p-2 d-flex ${orient === 'vertical' ? 'flex-column' : 'flex-row'} align-items-center justify-content-around ${className || ''}`}>
        {trueConfig.map((td, index) => {
          if (isTabletScreen && !td.mobile) return null;
          return (
            <AaGTd
              field={td.field}
              title={td.title}
              icon={td.icon}
              value={data[td.field]}
              size={size}
              data={data}
              isLoading={isLoading}
              diff={td.diff ? data[`${td.field}_diff`] : false}
              fieldStart={td.fieldStart}
              type={td.type}
              ignoreSuffix={td.ignoreSuffix}
              dollarSign={td.dollarSign}
              key={`aag-td-${td.field}-${index}`}
            />
          );
        })}
      </div>
  );
}

AtAGlance.displayName = "AtAGlance"

export default withErrorBoundary(AtAGlance, GeneralErrorBoundary);
